import favoritesStore from 'owa-favorites/lib/store/store';
import { FavoriteData } from 'owa-favorites-types';
import getSecondaryKey from 'owa-favorites/lib/utils/getSecondaryKey';

export default function isOutlookFavoritingInProgress(data: string | FavoriteData): boolean {
    if (!data) {
        return false;
    }

    const { favoritingInProgressMap } = favoritesStore;
    if (typeof data === 'string') {
        return favoritingInProgressMap.has(data);
    }

    return favoritingInProgressMap.has(getSecondaryKey(data));
}
